import { api } from "../api";
import { navigate } from "../router";

export async function addClientView(root: HTMLElement) {
  root.innerHTML = `
    <div class="topbar"><h1>Add client</h1></div>
    <div class="card">
      <div class="grid cols-2">
        <div>
          <label>Business name *</label><input id="business_name" />
          <label>Slug (used on every cloud host) *</label><input id="slug" placeholder="brand-city" />
          <label>Primary category</label><input id="primary_category" />
          <label>City</label><input id="city" />
          <label>State</label><input id="state" />
          <label>Zip</label><input id="zip" />
        </div>
        <div>
          <label>Address</label><input id="address" />
          <label>Phone</label><input id="phone" />
          <label>Email</label><input id="email" />
          <label>Owner name</label><input id="owner_name" />
          <label>Money site URL</label><input id="money_site_url" placeholder="https://example.com/" />
        </div>
      </div>
      <label>Claim block (canonical, byte-identical everywhere)</label>
      <textarea id="claim_block" rows="4"></textarea>
      <div id="err"></div>
      <button id="save" style="margin-top:14px">Create client</button>
    </div>
  `;
  root.querySelector<HTMLButtonElement>("#save")!.onclick = async () => {
    const val = (id: string) => (root.querySelector<HTMLInputElement | HTMLTextAreaElement>(`#${id}`)!.value.trim());
    const payload = {
      business_name: val("business_name"),
      slug: val("slug"),
      primary_category: val("primary_category"),
      city: val("city"),
      state: val("state"),
      zip: val("zip"),
      address: val("address"),
      phone: val("phone"),
      email: val("email"),
      owner_name: val("owner_name"),
      money_site_url: val("money_site_url"),
      claim_block: val("claim_block"),
    };
    if (!payload.business_name || !payload.slug) {
      root.querySelector("#err")!.innerHTML = `<div class="error-banner">Business name and slug are required.</div>`;
      return;
    }
    try {
      const res = await api<{ client: { id: string } }>("/v1/clients", { method: "POST", body: JSON.stringify(payload) });
      navigate(`/clients/${res.client.id}`);
    } catch (e) {
      root.querySelector("#err")!.innerHTML = `<div class="error-banner">${(e as Error).message}</div>`;
    }
  };
}
